export default function ApplicationLogo(props) {
    return (
        <img {...props} src={`/images/vault-logo.svg`} alt="United Home Loans" />
    );
}
